export default {
  namespaced: true,
  state: {
    baseURL: null,
    mediaURL: null,
    rowsPerPage: 20,
    rowsPerPageOptions: [5, 10, 20, 50, 100],
  },
  getters: {
    getBaseUrl(state) {
      return state.baseURL;
    },
    getMediaUrl(state) {
      return state.mediaURL;
    },
    getRowsPerPage(state) {
      return state.rowsPerPage;
    },
    getRowsPerPageOptions(state) {
      return state.rowsPerPageOptions;
    },
  },
  mutations: {
    SET_BASE_URL(state, data) {
      state.baseURL = data;
    },
    SET_MEDIA_URL(state, data) {
      state.mediaURL = data;
    },
    SET_ROWS_PER_PAGE(state, value) {
      state.rowsPerPage = value;
      localStorage.setItem('rowsPerPage', value);
    },
  },
  actions: {
    setBaseUrl({ commit }, url) {
      commit("SET_BASE_URL", url);
    },
    setMediaUrl({ commit }, url) {
      commit("SET_MEDIA_URL", url);
    },
    setRowsPerPage({ commit }, value) {
      commit("SET_ROWS_PER_PAGE", value);
    },
  },
};
